
import React, { useEffect, useState } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Loader from 'LegacyWeployDesignLanguage/loaders/Loader';

const StyledOverflowContainer = styled.div`
  height: ${props => props.height}vh;
  overflow-y: scroll;
`;

const InfiniteScroll = ({
  children,
  height,
  isEndReached,
  onBottomReached,
  triggerThreshold,
}) => {
  const infiniteScrollContainerRef = React.createRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleScroll = async () => {
    const scrollPosition = get(infiniteScrollContainerRef, 'current.scrollTop');
    const scrollHeight = get(infiniteScrollContainerRef, 'current.scrollHeight');
    const clientHeight = get(infiniteScrollContainerRef, 'current.clientHeight');
    const isAtBottomOfPage = (scrollPosition >= (scrollHeight - clientHeight - triggerThreshold));

    if (isAtBottomOfPage && !isLoading && !isEndReached) {
      setIsLoading(true);
      await onBottomReached();
      setIsLoading(false);
    }
  };

  useEffect(() => {
    infiniteScrollContainerRef.current.addEventListener('scroll', handleScroll);
  });

  return (
    <StyledOverflowContainer ref={infiniteScrollContainerRef} height={height}>
      {children}
      <Loader loading={isLoading} />
    </StyledOverflowContainer>
  );
};

InfiniteScroll.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  height: PropTypes.number,
  onBottomReached: PropTypes.func.isRequired,
  isEndReached: PropTypes.bool,
  triggerThreshold: PropTypes.number,
};

InfiniteScroll.defaultProps = {
  height: 75,
  isEndReached: false,
  triggerThreshold: 20,
};

export default InfiniteScroll;
